const modules = {
	title: "Modules",
	stitle: "Module",
	extra_title: "Extra modules",
	new_module: "New Module",
	edit_module: "Edit Module: {name}",
	list_title: "List of Modules",
	id: "ID",
	tenant_id: "Tenant",
	name: "Name",
	active_from: "Active from",
	inactive_from: "Inactive from",
	status: "Status",
	price: "Price",
	activated_by: "Activated by",
	activated_date: "Activated date",
	add_module: "Add Module",
	update_module: "Update Module",
};
export default modules;